import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SimpleContentWrapper from '../Blocks/SimpleContentWrapper';
import Faq from '../Blocks/Faq';
import SecondaryCTA from '../Blocks/SecondaryCTA';
import ReadyToGoCore from '../Blocks/ReadyToGoCore';
import ArtProtection from '../Blocks/ArtProtection';
import Hero from '../Blocks/Hero';
import Banner from '../Blocks/Banner';

export interface Props {}

const Picker: React.FC<Props> = () => {
  const isMobile = useContext(MobileContext);

  return (
    <SimpleContentWrapper>
      <Hero />
      {!isMobile && <SecondaryCTA />}
      <ArtProtection />
      <Faq />
      <ReadyToGoCore />
      <SecondaryCTA />
      <Banner />
    </SimpleContentWrapper>
  );
};
Picker.displayName = 'Picker';

export default Picker;
